import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { EXTERNAL_CONFIG } from './constants/const.config';
import { ConfigService } from './config.service';
import { AppConfig } from './config.contract';

@Injectable()
export class ConfigLoaderService {

  constructor(private http: HttpClient) { }

  load() {
    return this.readJsonConfig();
  }

// ToDo: verify config data with interface
  private readJsonConfig(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      // tslint:disable-next-line:no-trailing-whitespace
      
      const configFileUrl = '../config/' + environment.appConfigJsonFile;
      this.http.get(configFileUrl)
        .subscribe((data: any) => {
          EXTERNAL_CONFIG.appConfig = data;
          EXTERNAL_CONFIG.isLoaded = true;
          if (!environment.production) {
            // console.log('envConfig', EXTERNAL_CONFIG.appConfig );
            // console.log('environment', environment );
          }
          resolve(true);
        }, (error) => {
          EXTERNAL_CONFIG.isLoaded = false;
          if (error) {
            console.log(error);
            throw new Error(`Configuration file "${environment.appConfigJsonFile}" could not be read.
                                Make sure the config file has been well formatted if it is Json. `);
          }
          resolve(true);
        });

    });
  }

}



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/core/config/config-loader.service.ts